<template>
  <div>
    <div class="d-flex justify-content-between">
      <h3 class="d-flex align-items-center">
        <feather-icon class="mr-50" size="20" icon="CalendarIcon" />
        الخطة السنوية {{ year }}
      </h3>
      <div class="d-flex align-items-center">
        <b-button
          v-b-tooltip.hover.v-info.bottom
          title="تتبع الخطة"
          class="btn-icon rounded-circle mr-25"
          variant="flat-info"
          v-if="evaluated"
          @click="$router.push({ name: 'plan-execution' })"
        >
          <feather-icon size="18" icon="BarChartIcon" />
        </b-button>
        <b-button
          v-can="{slug:$route.meta.slug,action:'S'}"
          v-b-tooltip.hover.v-primary.bottom
          title="سجل الخطط"
          class="btn-icon rounded-circle mr-25"
          variant="flat-primary"
          @click="historyModal = true"
          v-if="(activePlan && activePlan.length > 0) ||(urgentPlan && urgentPlan.length > 0) "
        >
          <feather-icon size="18" icon="ClockIcon" />
        </b-button>
        <b-button
          v-can="{slug:$route.meta.slug,action:'C'}"
          v-b-tooltip.hover.v-success.bottom
          title="إضافة نشاط"
          class="btn-icon rounded-circle mr-25"
          variant="flat-success"
          @click="showActivityModal"
          v-if="(activePlan && activePlan.length > 0) ||(urgentPlan && urgentPlan.length > 0) "
        >
          <feather-icon size="18" icon="PlusIcon" />
        </b-button>
        <div style="position: relative">
          <div
            @click="onEvaluate"
            style="
              position: absolute;
              height: 100%;
              width: 100%;
              z-index: 2;
              cursor: pointer;
            "
          ></div>
          <!-- <b-form-checkbox
            :checked="evaluated"
            class="inline"
            :class="
              evaluated ? 'custom-control-success ' : 'custom-control-danger '
            "
            v-can="{slug:$route.meta.slug,action:'O'}"
          >
            <span :class="evaluated ? 'text-success ' : 'text-danger '">
              {{ evaluated ? "تم إعتماد الخطة" : "لم يتم الاعتماد بعد" }}
            </span>
          </b-form-checkbox> -->
        </div>
      </div>
    </div>

    <activity-modal
      
      :loading="working"
      @confirm="onAddActivity"
      v-model="ActivityModal"
    />
    <activity-modal
      :loading="working"
      @confirm="onUpdateActivity"
      v-model="editModal"
      :activityName="activityName"
      :intializeForm="editForm"
    />
    <plan-history-modal v-model="historyModal" />
    <hr />
    <div>
      <plan-table
        v-can="{slug:$route.meta.slug,action:'S'}"
        @deleteClicked="deleteActivity($event)"
        @editClicked="openEditModal"
        :planDetails.sync="activePlan"
        :loading="loading"
        :isArchived="year.toString() !== new Date().getFullYear().toString()"
        :evaluated.sync="evaluated"
      />
    </div>

    <!-- urgencies -->

    <div class="d-flex justify-content-between mt-2">
      <h3 class="d-flex align-items- center">
        <feather-icon class="mr-50" size="20" icon="CalendarIcon" />
        الأنشطة الطارئة
      </h3>
    </div>
    <hr />
    <plan-table
      v-can="{slug:$route.meta.slug,action:'S'}"
      @deleteClicked="deleteActivity($event)"
      @editClicked="openEditModal"
      :planDetails.sync="urgentPlan"
      :loading="loading"
      isUrgent
      :isArchived="year.toString() !== new Date().getFullYear().toString()"
      :evaluated.sync="evaluated"
    />
  </div>
</template>

<script>
import ActivityModal from "../../components/ActivityModal.vue";
import PlanTable from "../../components/PlanTable.vue";
import PlanHistoryModal from "../../components/PlanHistoryModal.vue";
import { mapGetters, mapActions } from "vuex";
import {
  BRow,
  BCol,
  BFormCheckbox,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
  VBTooltip,
} from "bootstrap-vue";

export default {
  components: {
    BRow,
    ActivityModal,
    PlanTable,
    PlanHistoryModal,
    BCol,
    BFormCheckbox,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BFormRadio,
    BForm,
    BFormTextarea,
    BButton,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    year: String | Number,
  },
  data() {
    return {
      ActivityModal: false,
      historyModal: false,
      editForm: {},
      editModal: false,
      activityName: null,
      evaluated: false,
    };
  },
  computed: {
    ...mapGetters("NgoPlan/Plan", [
      "currentPlan",
      "loading",
      "working",
      "archivedPlans",
      "programs",
      "urgentPlan",
    ]),
    ...mapGetters("NgoProfile", [ "canAddTransaction"]),
    activePlan() {
      if (this.year.toString() === new Date().getFullYear().toString()) {
        return this.programs;
      } else {
        var target = this.archivedPlans.find((el) => {
          return el.year.toString() === this.year.toString();
        });
        var x = [];
        x = target.programs;
        return x;
      }
    },
  },
  methods: {
    ...mapActions("NgoPlan/Plan", [
      "fetchPlan",
      "addActivity",
      "updateActivity",
      "deleteActivity",
    ]),
    showActivityModal() {
      this.ActivityModal = true;
    },
    onAddActivity(form) {
      this.addActivity(form);
      this.ActivityModal = false;
    },
    onUpdateActivity(form) {
      this.updateActivity(form);
      this.editModal = false;
    },
    onEvaluate() {
      this.boxTwo = "";
      const modalText = !this.evaluated
        ? "هل أنت متأكد من اعتماد الخطة ؟"
        : "هل أنت متأكد من الغاء اعتماد الخطة ؟";
      this.$bvModal
        .msgBoxConfirm(modalText, {
          title: "يرجى التأكيد",
          size: "sm",
          okVariant: !this.evaluated ? "primary" : "danger",
          okTitle: "نعم",
          cancelTitle: "لا",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) this.evaluated = !this.evaluated;
        });
    },
    openEditModal(rowData) {
      this.editForm = {
        activity_id: rowData.id,
        months: rowData.information.months,
        beneficiaries_number: rowData.information.beneficiaries_number,
        funds: rowData.information.funds,
      };
      this.activityName = rowData.name;
      this.editModal = true;
    },
  },
  created() {
    this.fetchPlan();
  },
};
</script>
